/**
 * First-party paths Segment traffic is proxied through so ad blockers can't drop it, paired with the
 * origins they forward to. The prefixes are repeated as literals in the `proxy.api.ts` matcher, which
 * Next.js cannot resolve from a constant.
 */
export const SEGMENT_PROXY_ROUTES = [
  { prefix: '/seg-api', upstreamOrigin: 'https://api.segment.io' },
  { prefix: '/seg-cdn', upstreamOrigin: 'https://cdn.segment.com' },
] as const
